<template>
  <dx-modal :value="show" :title="`Erros de validação do XML · Lote ${batch ? batch.number : ''}`"
            size="lg" id="modal-batch-xml-errors" @input="close()">
    <div class="stenci-group stenci-error">
      <p>O XML não foi gerado. Corrija os erros abaixo e tente novamente.</p>
    </div>
    <div class="cr-panel xml-errors-panel">
      <div class="cr-table-scroll">
        <table class="table">
          <thead>
          <tr>
            <th style="width: 30px">#</th>
            <th>Guia</th>
            <th>Campo</th>
            <th>Mensagem</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(error, index) in errors" :key="index">
            <td class="text-gray">{{ index + 1 }}</td>
            <td>
              <span class="text-bold num">{{ error.guideNumber || error.type || 'Lote' }}</span>
              <span class="sub" v-if="error.guideNumber && error.type">{{ error.type }}</span>
            </td>
            <td class="text-gray">{{ error.field || '—' }}</td>
            <td>{{ error.description }}</td>
            <td class="actions-cell">
              <button class="btn btn-sm btn-gray" v-if="error.guideId"
                      @click="$emit('open-guide', error.guideId)">Abrir guia</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="cr-box" v-if="warnings.length > 0">
      <div class="cr-box-title xml-warnings-title">
        <fa-icon :icon="['fal', 'exclamation-triangle']"/>Avisos (não impedem a geração)
      </div>
      <div class="text-small" v-for="(warning, index) in warnings" :key="index">
        {{ warning.message }}
      </div>
    </div>
    <template slot="footer">
      <button class="btn btn-primary btn-icon btn-icon-left mr-1" @click="$emit('retry')">
        <fa-icon :icon="['fal', 'sync']"/>Tentar novamente
      </button>
      <button class="btn" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    batch: {
      type: Object,
      default: null,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "../batch.scss";

#modal-batch-xml-errors {
  .xml-errors-panel {
    margin-top: 0;
  }
  .xml-warnings-title {
    color: #8A6D1F;
    font-size: $font-size-sm;
    svg {
      color: #8A6D1F;
    }
  }
}
</style>
